// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e3528249","453":"a3459e40","455":"ae575616","977":"56bb270d"}[chunkId] + ".chunk.js";
};